/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { loadUserActionsSummary } from '../../actions/userTracker';
import Loader from '../loader';
import { ROUTES } from '../../constants/routes';
import { generateUrl } from '../../routes/util';
import './styles.scss';

class UserActionsSummary extends Component {

  btnClick = (row) => () => this.linkTo(row);

  componentDidMount() {
    this.props.loadData();
  }

  render() {
    const { userActionsSummaryState } = this.props;

    if (!userActionsSummaryState.loaded) {
      return <Loader />;
    }

    return <div className='utrManagementContainer mb-5'>
      <div className='summaryTable m-3 mx-auto'>
        {this.renderTable(userActionsSummaryState.data)}
      </div>
    </div>
  }

  linkTo(row) {
    switch (row.type) {
      case 'utr':
        return this.props.history.push('#utr');
      case 'framework':
        return this.props.history.push(generateUrl(ROUTES.MANAGEMENT_FRAMEWORK, { initiativeId: row.id }));
      case 'survey':
        return this.props.history.push(generateUrl(ROUTES.COMPANY_TRACKER_SURVEY, { initiativeId: '', surveyId: row.id }));
      default:
    }
  }

  renderTitle(row) {
    switch (row.type) {
      case 'utr':
        return 'General Universal Trackers';
      case 'framework':
      case 'survey':
        return row.title;
      default:
        return '';
    }
  }

  getType(type) {
    switch (type) {
      case 'utr':
        return <i className='fa fas fa-2x fa-universal-access' />;
      case 'framework':
        return <i className='fa fas fa-2x fa-th' />;
      case 'survey':
        return <i className='fa fas fa-2x fa-list-ol' />;
      default:
        return '';
    }
  }

  renderTable(rows) {

    return <Fragment>
      <div className='row p-3'>
        <div className='col-6'></div>
        <div className='col-2 text-right align-middle'>
          <i className='fa fas fa-2x fa-user' title='Sole Responsibility' />
        </div>
        <div className='col-2 text-right align-middle'>
          <i className='fa fas fa-2x fa-users' title='Shared Responsibility' />
        </div>
        <div className='col-2 text-right align-middle'>
          <i className='fa fas fa-2x fa-exclamation-triangle' title='Urgent' />
        </div>
      </div>
      {rows.map((row, i) => {
        const highlightClassName = row.urgentCount > 0 ? 'urgentHighlight' : '';
        return <div key={i} className={'row p-2 align-items-center tableRow ' + highlightClassName} onClick={this.btnClick(row)}>
          <div className='col-1 text-center'>
            {this.getType(row.type)}
          </div>
          <div className='col-5 title'>
            {this.renderTitle(row)}
          </div>
          <div className='col-2 text-right'>
            <label className='m-0'>{row.soleCount ? row.soleCount : <span>-</span>}</label>
          </div>
          <div className='col-2 text-right'>
            <label className='m-0'>{row.sharedCount ? row.sharedCount : <span>-</span>}</label>
          </div>
          <div className='col-2 text-right'>
            <label className='m-0'>{row.urgentCount ? row.urgentCount : <span>-</span>}</label>
          </div>
        </div>
      })}
    </Fragment>
  }

}

const mapStateToProps = (state) => {
  return {
    userActionsSummaryState: state.userTrackersSummary,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    loadData: () => dispatch(loadUserActionsSummary()),
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UserActionsSummary));
